
import { EntityPeriodSettingsQueryDto } from 'src/app/core/models/entityPeriodSettingsQueryDto';
import { FormattingService } from 'src/app/core/services/formatting.service';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SiteInformationApiModel } from '../../../growR/models/siteInformationApiModel';
import { OnInit, OnDestroy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NewPeriodSelectorService } from 'src/app/core/services/new-period-selector.service';
import { NewCalendarPeriodFilter } from 'src/app/core/models/period-selector/newCalendarPeriodFilter';
import { SiteService } from 'src/app/core/services/site.service';


@Component({
    selector: 'app-information-site-header',
    templateUrl: './site-header.component.html',
    styleUrls: ['./site-header.component.scss'],
    standalone: false
})
export class SiteHeaderComponent implements OnInit, OnDestroy {

  settings: EntityPeriodSettingsQueryDto;
  site: SiteInformationApiModel;
  siteId: number;
  ngUnsubscribe = new Subject<boolean>();
  loading = true;
  periodFilter: NewCalendarPeriodFilter;

  constructor(
    private readonly siteService: SiteService,
    private readonly formattingService: FormattingService,
    private readonly newPeriodSelectorService: NewPeriodSelectorService,
    private readonly route: ActivatedRoute,
  ) { }

  ngOnInit() {
    combineLatest([
      this.route.paramMap,
      this.newPeriodSelectorService.getCalendarPeriodFilter()]
    ).pipe(takeUntil(this.ngUnsubscribe)).subscribe(results => {
      this.siteId = +results[0].get('siteId');
      this.periodFilter = results[1];
      this.loadData();
    });
  }

  loadData() {
    this.settings = {
      entityId: this.siteId,
      periodInterval: {
        startDate: this.periodFilter.startDate,
        endDate: this.periodFilter.endDate
      }
    };

    this.loading = true;
    this.siteService.GetGrowRSiteInformation(this.settings).subscribe(response => {
      this.site = response;
      this.site.area.value = this.formattingService.getDisplayFormattedNumber(this.site.area.value, false);
      this.loading = false;
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next(true);
    this.ngUnsubscribe.complete();
  }
}
